import { render } from "./Failed.vue?vue&type=template&id=b15ad8e8&scoped=true"
import script from "./Failed.vue?vue&type=script&lang=js"
export * from "./Failed.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-b15ad8e8"

export default script